import { coreApi as api } from "../core/BaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiMailTemplates: build.query<
      GetApiMailTemplatesApiResponse,
      GetApiMailTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/MailTemplates`,
        params: { companyId: queryArg.companyId },
      }),
    }),
    getApiMailTemplatesActives: build.query<
      GetApiMailTemplatesActivesApiResponse,
      GetApiMailTemplatesActivesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/MailTemplates/actives`,
        params: { companyId: queryArg.companyId },
      }),
    }),
    getApiMailTemplatesById: build.query<
      GetApiMailTemplatesByIdApiResponse,
      GetApiMailTemplatesByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/MailTemplates/${queryArg.id}` }),
    }),
    postApiMailTemplatesSave: build.mutation<
      PostApiMailTemplatesSaveApiResponse,
      PostApiMailTemplatesSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/MailTemplates/save`,
        method: "POST",
        body: queryArg.saveMailTemplateDto,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiMailTemplatesApiResponse = unknown;
export type GetApiMailTemplatesApiArg = {
  companyId?: string;
};
export type GetApiMailTemplatesActivesApiResponse = unknown;
export type GetApiMailTemplatesActivesApiArg = {
  companyId?: string;
};
export type GetApiMailTemplatesByIdApiResponse = unknown;
export type GetApiMailTemplatesByIdApiArg = {
  id: string;
};
export type PostApiMailTemplatesSaveApiResponse = unknown;
export type PostApiMailTemplatesSaveApiArg = {
  saveMailTemplateDto: SaveMailTemplateDto;
};
export type SaveMailTemplateDto = {
  id?: string;
  companyId?: string;
  name?: string | null;
  desc?: string | null;
  templateKey?: string | null;
  templateSubject?: string | null;
  templateContent?: string | null;
  isDefault?: boolean;
};
export const {
  useGetApiMailTemplatesQuery,
  useLazyGetApiMailTemplatesQuery,
  useGetApiMailTemplatesActivesQuery,
  useLazyGetApiMailTemplatesActivesQuery,
  useGetApiMailTemplatesByIdQuery,
  useLazyGetApiMailTemplatesByIdQuery,
  usePostApiMailTemplatesSaveMutation,
} = injectedRtkApi;
